/* istanbul ignore file */
// libs
import React from 'react';
// components
import { BaseInputLayout, ErrorMessage } from 'framework/ui/layout';
import { Box, Typography } from '@mui/material';

type FileUploadLayoutPros = {
  label: string;
  tooltip: string;
  previews: any;
  fileUploder: any;
  error: Nullable<ErrorMessage[]>;
  disabled: boolean;
  helpText: string;
  source: string;
  isVisible: boolean;
  isRequired: boolean;
};

const FileUploadLayout = ({
  label,
  tooltip,
  previews,
  isRequired = false,
  fileUploder,
  error,
  disabled = false,
  helpText,
  source,
  isVisible,
}: FileUploadLayoutPros) => {
  return (
    <BaseInputLayout
      label={label}
      isRequired={isRequired}
      errorMessages={error}
      tooltip={tooltip}
      source={source}
      isVisible={isVisible}
      sx={{ '& > .MuiFormHelperText-root': { marginLeft: 0 } }}
    >
      <Box
        className="upload-block"
        data-testid="upload-block"
        sx={theme => ({
          display: 'grid',
          gap: '20px',
          gridTemplateColumns: 'repeat(auto-fill, 100px)',
          [theme.breakpoints.down('smallMobile')]: {
            gridTemplateColumns: 'repeat(auto-fill, 50px)',
          },
        })}
      >
        {previews}
        {fileUploder}
      </Box>
      <>
        {!disabled && (
          <Typography
            className="upload-help-text"
            data-testid="upload-help-text"
            component="span"
            variant="inherit"
            sx={{
              color: 'text.secondary',
              fontSize: '11px',
              lineHeight: 1.4,
              display: 'block',
              width: '100%',
              mt: '5px',
            }}
          >
            {helpText}
          </Typography>
        )}
      </>
    </BaseInputLayout>
  );
};

export default FileUploadLayout;
